import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const getMentorName = () => {
  return api
    .get(API_URL + "mentors/name")
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getMentorEmail = () => {
  return api
    .get(API_URL + "mentors/email")
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getMentorsRelationStd = () => {
  return api
    .get(API_URL + "mentors/std")
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};
